module.exports = __webpack_public_path__ + "img/lady-bug.a32e1cb.svg";